import * as React from 'react'
import { SVGProps, memo } from 'react'

const BlogIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={20}
    height={23}
    fill='none'
    {...props}
  >
    <path
      fill='currentColor'
      fillRule='evenodd'
      d='M15.729.223c-.367.234-4.523 4.448-9.987 10.125-3.513 3.65-3.526 3.665-4.009 4.712C.923 16.819-.003 19.365 0 19.831c.005.87 1.13 2.438 2.091 2.917.581.289 2.296.34 3.245.098 1.077-.276 2.739-1.136 4.667-2.417 1.95-1.293 2.47-1.58 3.328-1.838.878-.263 1.408-.237 1.727.085.248.25.502.915.504 1.316.001.415.265.903.575 1.065.266.139.401.147.715.042.638-.212.755-.509.614-1.563-.148-1.112-.505-1.848-1.19-2.457-.588-.522-1.054-.688-1.937-.686-1.492.002-2.786.544-5.226 2.187-.886.596-1.911 1.253-2.278 1.46-1.624.913-3.502 1.23-4.12.694l-.296-.257 1.844-.82c1.639-.727 1.93-.898 2.614-1.538C8.173 16.908 18.574 5.92 19.544 4.738c.35-.427.406-.581.446-1.211.031-.493-.011-.874-.135-1.2-.192-.506-1.3-1.74-1.888-2.102-.486-.3-1.77-.3-2.238-.002Zm1.925 2.414c.256.28.465.554.465.609 0 .18-.465.732-1.599 1.896l-1.12 1.15-.747-.748-.747-.749 1.022-1.12C16.146 2.34 16.727 1.876 17 2.024c.104.056.399.331.655.612ZM13.337 7.02l.714.728L13 8.843c-.578.603-2.61 2.714-4.515 4.692l-3.463 3.596-1.127.486c-.62.267-1.15.462-1.177.434-.028-.028.158-.577.413-1.22.53-1.34 0-.715 5.736-6.752 1.98-2.082 3.634-3.786 3.677-3.786.043 0 .4.327.793.727Z'
      clipRule='evenodd'
    />
  </svg>
)

const Memo = memo(BlogIcon)
export default Memo
